/**** Youtube ****/
$(".content-edit iframe").wrap('<div class="youtube-video"></div>');

if ($(".partners-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideHomePartner = new Splide(".partners-slider", {
      type: "loop",
      drag: false,
      focus: "center",
      gap: "16px",
      fixedHeight: "95px",
      autoWidth: true,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 0.5,
        pauseOnHover: false,
      },
      breakpoints: {
        767: {
          fixedHeight: "64px",
        },
      },
    }).mount(window.splide.Extensions);
  });
}

if ($(".related-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".related-slider", {
      pagination: false,
      arrows: true,
      perPage: 3,
      drag: true,
      autoplay: true,
      speed: 3000,
      rewind: true,
      breakpoints: {
        992: {
          perPage: 2,
        },
        540: {
          perPage: 1,
        },
      },
    }).mount();
  });
}

if ($(".activities-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".activities-slider", {
      pagination: false,
      arrows: true,
      gap: "16px",
      fixedHeight: "272px",
      fixedWidth: "294px",
      drag: true,
      rewind: true,
      breakpoints: {
        767: {
          fixedHeight: "272px",
          fixedWidth: "280px",
        },
      },
    }).mount();
  });
}

if ($(".content-gallery").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".content-gallery", {
      pagination: false,
      arrows: true,
      perPage: 1,
      drag: true,
      autoplay: true,
      speed: 3000,
    }).mount();
  });
}

if ($(".product-cat-slider").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var splideOf = new Splide(".product-cat-slider", {
      pagination: false,
      arrows: true,
      autoWidth: true,
      gap: 48,
      drag: true,
      autoplay: false,
      speed: 3000,
      breakpoints: {
        970: {
          gap: 24,
        },
      },
    }).mount();
  });
}

if ($("#big-image").length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    var main = new Splide("#big-image", {
      rewind: true,
      pagination: false,
      arrows: false,
    });

    var thumbnails = new Splide("#small-images", {
      fixedWidth: 140,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        768: {
          gap: 12,
        },
      },
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  });
}

/**** Add review start ****/

$("#show-review").on("click", function () {
  $("#add-review").toggle("slow");
  reviewFormValidation();
});

/**** Add review end ****/

$("table.table").wrap("<div class='table-responsive'></div>");

/**** SHOP ****/

$(".filters-button").on("click", function () {
  var button = $(this);
  var filters = $("#" + button.attr("aria-controls"));

  if (filters.length === 0) {
    return;
  }

  var isOpen = !filters.hasClass("is-open");
  filters.toggleClass("is-open", isOpen);
  button.attr("aria-expanded", isOpen ? "true" : "false");
});

$(".close-filters").on("click", function () {
  var filters = $(this).closest(".filters-list-wrapper");
  var filterId = filters.attr("id");
  var button = $(".filters-button").filter(function () {
    return $(this).attr("aria-controls") === filterId;
  });

  filters.removeClass("is-open");
  button.attr("aria-expanded", "false").first().trigger("focus");
});

$(".filter-title").on("click", function () {
  if (window.matchMedia("(min-width: 768px)").matches) {
    return;
  }

  $(this).closest(".filter-subsection").find(".filter-items").toggleClass("is-collapsed");
  $(this).children(".show-filters").toggleClass("open");
});

$(".open-filters").on("click", function () {
  $(".product-filters").addClass("is-active");
  $("body").addClass("filters-opened");
});

$(".product-filters .icon-down").on("click", function () {
  $(".product-filters").removeClass("is-active");
  $("body").removeClass("filters-opened");
});

$(".btn-submit-form").on("click", function () {
  $("#order-form").submit();
});

/**** END SHOP ****/

// AJAX CONTENT LOADER
var loader = {
  init: function (
    triggerSelector,
    targetSelector,
    callbackBefore,
    callbackAfter
  ) {
    $("body").on("click", triggerSelector, function () {
      window.history.pushState(null, null, $(this).attr("href"));

      if (callbackBefore !== undefined) {
        callbackBefore($(this));
      }

      loader.load($(this).attr("href"), targetSelector, callbackAfter);

      return false;
    });
  },
  load: function (url, targetSelector, callbackAfter) {
    $(".list-loader").show();

    url += url.includes("?") ? "&ajax" : "?ajax";

    $.get(url).then(function (response) {
      $(targetSelector).html(response);
    });
  },
};

// news LIST
loader.init(".news-list-pagination a", ".news-list-dynamic");
loader.init(".news-list-link", ".news-list-dynamic", function (trigger) {
  if (trigger.hasClass("news-list-link")) {
    $(".news-filters .active").removeClass("active");
    trigger.parent().addClass("active");
  }
});

var relatedPlaceholder = $(".related-products-placeholder");
if (relatedPlaceholder.length > 0) {
  relatedPlaceholder.prepend(
    '<div class="list-loader"><div class="inner"><div></div><div></div><div></div></div></div>'
  );

  $.get(
    "/product/related/" + relatedPlaceholder.data("id"),
    function (response) {
      relatedPlaceholder.html(response);

      if ($(".related-products-slider").length > 0) {
        var splide = new Splide(".related-products-slider", {
          pagination: false,
          arrows: true,
          drag: true,
          perPage: 4,
          autoplay: false,
          speed: 3000,
          rewind: true,
          breakpoints: {
            991: {
              perPage: 3,
            },
            700: {
              perPage: 2,
            },
            420: {
              perPage: 1,
            },
          },
        }).mount();
      }

      //Ecommerce select item
      $(".single-related-product").on("click", function () {
        var singleRelated = $(this);
        var pageInfo = $(".data-container h1");

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "select_item",
          ecommerce: {
            item_list_id: pageInfo.data("pageid"),
            item_list_name: pageInfo.data("name"),
            items: [
              {
                item_id: singleRelated.data("productcode"),
                item_name: singleRelated.data("name"),
                price: singleRelated.data("price"),
                discount: singleRelated.data("discount"),
                item_category: singleRelated.data("category"),
              },
            ],
          },
        });
      });
    }
  );
}

if ($(".related-products-slider-orders").length > 0) {
  var splide = new Splide(".related-products-slider-orders", {
    pagination: false,
    arrows: true,
    drag: true,
    perPage: 5,
    autoplay: false,
    speed: 3000,
    rewind: true,
    breakpoints: {
      991: {
        perPage: 3,
      },
      700: {
        perPage: 2,
      },
      420: {
        perPage: 1,
      },
    },
  }).mount();
}

if ($(".related-products-slider-custom").length > 0) {
  var splide = new Splide(".related-products-slider-custom", {
    pagination: false,
    arrows: true,
    drag: true,
    perPage: 5,
    gap: 16,
    autoplay: false,
    speed: 3000,
    rewind: true,
    breakpoints: {
      991: {
        perPage: 3,
      },
      700: {
        perPage: 2,
      },
    },
  }).mount();
}

var productList = {
  loadRequest: null,
  filterTypes: null,
  filters: null,
  load: function (url) {
    $(".products-list-placeholder").prepend(
      '<div class="list-loader"><div class="inner"></div></div>'
    );

    window.history.pushState(null, null, url);

    if (productList.loadRequest != null) {
      productList.loadRequest.abort();
    }

    url = url.split("#")[0] + (url.includes("?") ? "&ajax" : "?ajax");

    productList.loadRequest = $.get(url, function (response) {
      $(".products-list-placeholder").html(response);

      $(".pagination-page").on("click", function () {
        productList.load($(this).attr("href"));
        window.scrollTo(0, 0);
        return false;
      });

      $(".pl-data-url").on("click", function () {
        productList.load($(this).data("url"));
        window.scrollTo(0, 0);
        return false;
      });

      // // Ecommerce view item list
      // var pageContents = [];
      // $(".products-list-placeholder .single-product").each(function () {
      //     pageContents.push({
      //         'item_id': $(this).data("productcode"),
      //         'item_name': $(this).data("title"),
      //         'discount': $(this).data("discount"),
      //         'price': $(this).data("price")
      //     });
      // });

      // dataLayer.push({ ecommerce: null });
      // dataLayer.push({
      //     event: "view_item_list",
      //     ecommerce: {
      //         item_list_id: $(".products-list-placeholder").data("id"),
      //         item_list_name: $(".products-list-placeholder").data("title"),
      //         items: [
      //             pageContents
      //         ]
      //     }
      // });

      // //Ecommerce select item
      // $(".single-product").on('click', function() {
      //     var clickedProduct = $(this);

      //     dataLayer.push({ ecommerce: null });
      //     dataLayer.push({
      //         event: "select_item",
      //         ecommerce: {
      //             item_list_id: clickedProduct.data("pageid"),
      //             item_list_name: clickedProduct.data("page"),
      //             items: [
      //                 {

      //                     item_id: clickedProduct.data("productcode"),
      //                     item_name: clickedProduct.data("title"),
      //                     price: clickedProduct.data('price'),
      //                     discount: clickedProduct.data("discount"),
      //                     item_category: clickedProduct.data("category"),
      //                 }
      //             ]
      //         }
      //     });
      // });
    });
  },
  initFilters: function () {
    productList.filterTypes = productList.getFilterTypes();
    productList.filters = productList.getFiltersFromUrl();

    productList.preselectFilters();
    $(".filter input").on("change", function () {
      productList.changeFilter($(this));
    });
    $(".reset-filters").on("click", function () {
      productList.resetFilters();
    });
  },
  resetFilters: function () {
    $(".filter input").prop("checked", false);
    productList.filters = {};
    productList.writeFiltersToUrl();
  },
  changeFilter: function (filter) {
    var value = encodeURI(filter.val());
    var filterType = filter.closest(".filter-subsection").data("type");

    if (filter.is(":checked")) {
      productList.addFilterToList(filterType, value);
    } else {
      productList.removeFilterFromList(filterType, value);
    }

    productList.writeFiltersToUrl();
  },
  addFilterToList: function (filterType, value) {
    if (productList.filters[filterType] === undefined) {
      productList.filters[filterType] = [];
    }
    productList.filters[filterType].push(value);
  },
  removeFilterFromList: function (filterType, value) {
    if (value == null) {
      delete productList.filters[filterType];
    } else {
      productList.filters[filterType].splice(
        productList.filters[filterType].indexOf(value),
        1
      );
      if (productList.filters[filterType].length == 0) {
        delete productList.filters[filterType];
      }
    }
  },
  writeFiltersToUrl: function () {
    var filtersUrl = [];
    var filterTypes = productList.filterTypes;
    for (var i = 0; i < filterTypes.length; i++) {
      if (productList.filters[filterTypes[i]] !== undefined) {
        filtersUrl.push(
          filterTypes[i] +
            "[" +
            productList.filters[filterTypes[i]].join(",") +
            "]"
        );
        // hash += filterTypes[i] + '[' + parseInt(productList.filters[filterTypes[i]]) + ']';
      }
    }

    var urlFilters =
      filtersUrl.length > 0 ? "filters=" + filtersUrl.join(";") : "";
    var url = location.href;
    var hashIndex = url.indexOf("#");
    var hash = hashIndex > -1 ? url.substr(hashIndex) : "";
    var urlWithoutHash = hashIndex > -1 ? url.substr(0, hashIndex) : url;
    var queryIndex = urlWithoutHash.indexOf("?");
    var path =
      queryIndex > -1 ? urlWithoutHash.substr(0, queryIndex) : urlWithoutHash;
    var query = queryIndex > -1 ? urlWithoutHash.substr(queryIndex + 1) : "";
    var queryParams = query ? query.split("&") : [];

    queryParams = queryParams.filter(function (param) {
      var key = param.split("=")[0];
      return key !== "filters" && key !== "page";
    });

    if (urlFilters !== "") {
      queryParams.push(urlFilters);
    }

    url =
      path + (queryParams.length > 0 ? "?" + queryParams.join("&") : "") + hash;
    productList.load(url);
  },
  getFiltersFromUrl: function () {
    var filterTypes = productList.filterTypes;
    var filters = {};
    var found = location.href.match(/filters=(.*?)(?:\&.*)*$/);
    if (found != null) {
      var f = found[1].split(";");
      for (var i = 0; i < filterTypes.length; i++) {
        var pattern = new RegExp(filterTypes[i] + "\\[(.*?)\\]");
        var result = pattern.exec(f);
        if (result !== null) {
          filters[filterTypes[i]] = result[1].split(",");
          if (filters[filterTypes[i]] !== undefined) {
            for (var j = 0; j < filters[filterTypes[i]].length; j++) {
              filters[filterTypes[i]][j] = decodeURI(
                filters[filterTypes[i]][j]
              );
            }
          }
        }
      }
    }

    return filters;
  },
  getFilterTypes: function () {
    if (productList.filterTypes === null) {
      productList.filterTypes = [];
      $(".filter-section .filter-subsection").each(function () {
        productList.filterTypes.push($(this).data("type"));
      });
    }
    return productList.filterTypes;
  },
  preselectFilters: function () {
    for (var type in productList.filters) {
      var parent = $('.filter-subsection[data-type="' + type + '"]');

      for (var i = 0; i < productList.filters[type].length; i++) {
        parent
          .find(
            "input[value='" + decodeURI(productList.filters[type][i]) + "']"
          )
          .prop("checked", true);
      }
    }
  },
};

if ($(".products-list-placeholder").length > 0) {
  productList.load(location.href);
}

if ($(".product-filters").length > 0) {
  productList.initFilters();
}

$(function () {
  $(".short-description").each(function () {
    var shortDescription = $(this);
    var content = shortDescription.find(".short-description-content");
    var button = shortDescription.find(".read-more-text");

    if (!content.length || content[0].scrollHeight <= 120) {
      button.hide();
      return;
    }

    button.on("click", function () {
      var isExpanded = shortDescription.hasClass("is-expanded");

      shortDescription.toggleClass("is-expanded", !isExpanded);
      button.text(
        isExpanded ? button.data("read-more") : button.data("read-less")
      );
    });
  });
});

$(".btn-plus, .btn-minus").on("click", function (e) {
  var isNegative = $(e.target).closest(".btn-minus").is(".btn-minus");
  var input = $(e.target).closest(".quantity").find("input");
  if (input.is("input")) {
    input[0][isNegative ? "stepDown" : "stepUp"]();
  }
});
